// Shared TanStack Query client. Kept in a standalone module so both App.js
// and any imperative helper can `invalidateQueries` through the same instance.
//
// Defaults tuned for the booking app:
//   • staleTime 30 s   — recent fetches are served instantly without a network trip
//   • gcTime 5 min     — unused data is garbage-collected after 5 min
//   • refetchOnWindowFocus: false — the app is mostly single-session, avoid flicker
//   • retry: 1         — single silent retry for transient network errors
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// Convenience query keys for the domain endpoints the app caches.
export const qk = {
  bookings: (studentEmail) => studentEmail ? ['bookings', studentEmail] : ['bookings'],
  calendar: (scope) => ['calendar', scope],
  gamesStats: (studentId) => ['games-stats', studentId],
};
